"use client";

import { UserContext } from "@/contexts/user-context";
import { useImmer } from "use-immer";
import { ReactNode } from "react";

type PropsUserProvider = {
  children?: ReactNode;
  value: UserVM;
};

export const UserProvider = ({ children, value: v }: PropsUserProvider) => {
  const [value, setValue] = useImmer<UserVM | Record<string, any>>(v);
  return (
    <UserContext.Provider value={{ ...value, setUser: setValue }}>
      {children}
    </UserContext.Provider>
  );
};
